(function () {
  'use strict';

  if (window.__jfcCartValidationInitialized) return;
  window.__jfcCartValidationInitialized = true;

  var MINIMUM_CENTS = 5000;
  var ADL_ALCOHOL_MINIMUM_GRAMS = 4500;
  var CART_URL = '/cart';
  var FETCH_TIMEOUT_MS = 5000;

  var MESSAGES = {
    SYD_MINIMUM: 'Sydney orders require a minimum subtotal of $50.00.',
    ADL_ALCOHOL_MINIMUM: 'Adelaide alcohol orders require at least 4.5 kg of alcohol in the cart.',
    STATE_PENDING: 'We could not confirm the current cart requirements. Please wait and try again.',
    VALIDATION_UNAVAILABLE: 'We could not confirm the current cart requirements. Please wait and try again.'
  };

  function normalizeRegion(region) {
    return region === 'ADL' ? 'ADL' : 'SYD';
  }

  function isNonNegativeInteger(value) {
    return Number.isFinite(value) && value >= 0 && Math.floor(value) === value;
  }

  function isValidFreshState(snapshot) {
    return snapshot &&
      snapshot.status === 'FRESH' &&
      isNonNegativeInteger(snapshot.totalCents) &&
      typeof snapshot.hasAlcohol === 'boolean' &&
      isNonNegativeInteger(snapshot.alcoholGrams) &&
      (snapshot.hasAlcohol || snapshot.alcoholGrams === 0);
  }

  function evaluate(snapshot, region) {
    var reason = '';
    var normalizedRegion = normalizeRegion(region);

    if (!snapshot || snapshot.status === 'PENDING') {
      reason = 'STATE_PENDING';
    } else if (snapshot.status === 'ERROR' || !isValidFreshState(snapshot)) {
      reason = 'VALIDATION_UNAVAILABLE';
    } else if (normalizedRegion === 'SYD' && snapshot.totalCents < MINIMUM_CENTS) {
      reason = 'SYD_MINIMUM';
    } else if (
      normalizedRegion === 'ADL' &&
      snapshot.hasAlcohol &&
      snapshot.alcoholGrams < ADL_ALCOHOL_MINIMUM_GRAMS
    ) {
      reason = 'ADL_ALCOHOL_MINIMUM';
    }

    var blocked = reason !== '';
    return {
      disabled: blocked,
      ariaDisabled: blocked ? 'true' : 'false',
      reason: reason,
      message: reason ? MESSAGES[reason] : '',
      submitBlocked: blocked,
      additionalHidden: blocked
    };
  }


  window.__jfcCartValidationApi = Object.freeze({
    evaluate: evaluate,
    parseCanonicalState: parseCanonicalState,
    messages: Object.freeze(Object.assign({}, MESSAGES))
  });

  if (typeof document === 'undefined') return;

  var state = {
    status: 'PENDING',
    totalCents: null,
    hasAlcohol: null,
    alcoholGrams: null,
    version: 0
  };
  var inFlight = null;
  var requestedGeneration = 0;
  var completedGeneration = 0;
  var initialFetchAttempted = false;

  function parseBoolean(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return null;
  }

  function parseNonNegativeInteger(value) {
    if (typeof value !== 'string' || !/^(0|[1-9][0-9]*)$/.test(value)) return null;
    var parsed = Number(value);
    return Number.isSafeInteger(parsed) ? parsed : null;
  }

  function parseCanonicalState(root) {
    var elements = root.querySelectorAll('[data-jfc-cart-state]');
    if (elements.length !== 1) return null;

    var element = elements[0];
    var totalCentsRaw = element.getAttribute('data-jfc-total-cents');
    var hasAlcoholRaw = element.getAttribute('data-jfc-has-alcohol');
    var alcoholGramsRaw = element.getAttribute('data-jfc-alcohol-grams');
    if (totalCentsRaw === null || hasAlcoholRaw === null || alcoholGramsRaw === null) return null;

    var totalCents = parseNonNegativeInteger(totalCentsRaw);
    var hasAlcohol = parseBoolean(hasAlcoholRaw);
    var alcoholGrams = parseNonNegativeInteger(alcoholGramsRaw);
    if (totalCents === null || hasAlcohol === null || alcoholGrams === null) return null;
    var candidate = {
      status: 'FRESH',
      totalCents: totalCents,
      hasAlcohol: hasAlcohol,
      alcoholGrams: alcoholGrams
    };

    return isValidFreshState(candidate) ? candidate : null;
  }

  function currentView() {
    return evaluate(state, window.__jfcRegionTag);
  }

  function setButtonState(button, view) {
    button.disabled = view.disabled;
    button.classList.toggle('disabled', view.disabled);
    button.setAttribute('aria-disabled', view.ariaDisabled);
    if (view.reason) button.setAttribute('data-jfc-validation-reason', view.reason);
    else button.removeAttribute('data-jfc-validation-reason');
  }

  function setAdditionalState(wrapper, view) {
    if (view.additionalHidden) {
      wrapper.setAttribute('data-jfc-hidden-by-guard', 'true');
      wrapper.hidden = true;
      wrapper.setAttribute('aria-hidden', 'true');
      wrapper.style.pointerEvents = 'none';
      return;
    }

    wrapper.hidden = false;
    wrapper.removeAttribute('data-jfc-hidden-by-guard');
    wrapper.setAttribute('aria-hidden', 'false');
    wrapper.style.removeProperty('pointer-events');
  }

  function render() {
    var view = currentView();

    document.querySelectorAll('[data-jfc-checkout-guard]').forEach(function (button) {
      setButtonState(button, view);
    });
    document.querySelectorAll('[data-jfc-cart-validation-message]').forEach(function (message) {
      message.textContent = view.message;
      message.hidden = view.message === '';
      message.setAttribute('data-jfc-validation-reason', view.reason);
    });
    document.querySelectorAll('[data-jfc-additional-checkout-guard]').forEach(function (wrapper) {
      setAdditionalState(wrapper, view);
    });
  }

  function guardElementNeedsRepair(element, view) {
    if (element.matches('[data-jfc-checkout-guard]')) {
      return element.disabled !== view.disabled ||
        element.classList.contains('disabled') !== view.disabled ||
        element.getAttribute('aria-disabled') !== view.ariaDisabled ||
        (element.getAttribute('data-jfc-validation-reason') || '') !== view.reason;
    }

    if (element.matches('[data-jfc-cart-validation-message]')) {
      return element.hidden !== (view.message === '') ||
        (element.getAttribute('data-jfc-validation-reason') || '') !== view.reason ||
        element.textContent.trim() !== view.message;
    }

    if (element.matches('[data-jfc-additional-checkout-guard]')) {
      if (view.additionalHidden) {
        return !element.hidden ||
          element.getAttribute('data-jfc-hidden-by-guard') !== 'true' ||
          element.getAttribute('aria-hidden') !== 'true' ||
          element.style.pointerEvents !== 'none';
      }
      return element.hidden ||
        element.getAttribute('data-jfc-hidden-by-guard') === 'true' ||
        element.getAttribute('aria-hidden') !== 'false' ||
        element.style.pointerEvents === 'none';
    }

    return false;
  }

  function commitState(nextState) {
    state = {
      status: nextState.status,
      totalCents: nextState.totalCents,
      hasAlcohol: nextState.hasAlcohol,
      alcoholGrams: nextState.alcoholGrams,
      version: state.version + 1
    };
    render();
  }

  function setPending() {
    commitState({ status: 'PENDING', totalCents: null, hasAlcohol: null, alcoholGrams: null });
  }

  function setError() {
    commitState({ status: 'ERROR', totalCents: null, hasAlcohol: null, alcoholGrams: null });
  }

  function fetchGeneration(generation) {
    var controller = new AbortController();
    var timeoutId = window.setTimeout(function () {
      controller.abort();
    }, FETCH_TIMEOUT_MS);

    return window.fetch(CART_URL, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'error',
      headers: { Accept: 'text/html' },
      signal: controller.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart response was not successful');
        var responseUrl = new URL(response.url);
        if (response.redirected || responseUrl.origin !== window.location.origin || responseUrl.pathname !== CART_URL) {
          throw new Error('cart response URL was not allowed');
        }
        return response.text();
      })
      .then(function (html) {
        if (generation !== requestedGeneration) return false;
        var parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        var nextState = parseCanonicalState(parsedDocument);
        if (!nextState) throw new Error('canonical cart state was missing or invalid');
        commitState(nextState);
        return true;
      })
      .catch(function () {
        if (generation === requestedGeneration) setError();
        return false;
      })
      .finally(function () {
        window.clearTimeout(timeoutId);
      })
      .then(function (result) {
        completedGeneration = generation;
        if (generation < requestedGeneration) return fetchGeneration(requestedGeneration);
        return result;
      });
  }

  function ensureRefreshWorker() {
    if (!inFlight) {
      inFlight = fetchGeneration(requestedGeneration).finally(function () {
        inFlight = null;
      });
    }
    return inFlight;
  }

  function waitForLatestRefresh() {
    return ensureRefreshWorker().then(function (result) {
      if (completedGeneration < requestedGeneration) return waitForLatestRefresh();
      return result;
    });
  }

  function refreshFromCart() {
    requestedGeneration += 1;
    initialFetchAttempted = true;
    setPending();
    return waitForLatestRefresh();
  }

  function hasGuardElements() {
    return document.querySelector('[data-jfc-checkout-guard],[data-jfc-additional-checkout-guard]') !== null;
  }

  function installRegionHook() {
    var originalApplyFilter = window.__jfcApplyFilter;
    window.__jfcApplyFilter = function () {
      var result;
      if (typeof originalApplyFilter === 'function') {
        result = originalApplyFilter.apply(this, arguments);
      }
      render();
      return result;
    };
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var submitter = event.submitter;
    if (!(form instanceof HTMLFormElement)) return;
    if (!submitter || !submitter.matches('[data-jfc-checkout-guard]')) return;

    var approvedVersion = form.getAttribute('data-jfc-approved-version');
    var view = currentView();
    if (
      approvedVersion === String(state.version) &&
      state.status === 'FRESH' &&
      !view.submitBlocked
    ) {
      form.removeAttribute('data-jfc-approved-version');
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    refreshFromCart().then(function () {
      var refreshedView = currentView();
      if (state.status !== 'FRESH' || refreshedView.submitBlocked) return;
      if (typeof form.requestSubmit !== 'function') {
        setError();
        return;
      }
      form.setAttribute('data-jfc-approved-version', String(state.version));
      form.requestSubmit(submitter);
    });
  }, true);

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;
    var target = new URL(link.href, window.location.origin);
    if (target.origin !== window.location.origin || target.pathname !== '/checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(CART_URL);
  }, true);

  document.addEventListener('cart:updated', function () {
    refreshFromCart();
  });

  var attributeFilter = [
    'disabled',
    'class',
    'aria-disabled',
    'data-jfc-validation-reason',
    'hidden',
    'aria-hidden',
    'data-jfc-hidden-by-guard',
    'style'
  ];
  var observedGuardElements = new WeakSet();
  var attributeObserver = new MutationObserver(function (mutations) {
    var view = currentView();
    if (mutations.some(function (mutation) {
      var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      if (!target) return false;
      var guard = target.matches(
        '[data-jfc-checkout-guard],[data-jfc-cart-validation-message],[data-jfc-additional-checkout-guard]'
      ) ? target : target.closest('[data-jfc-cart-validation-message]');
      return guard ? guardElementNeedsRepair(guard, view) : false;
    })) render();
  });

  function observeGuardAttributes() {
    document.querySelectorAll(
      '[data-jfc-checkout-guard],[data-jfc-cart-validation-message],[data-jfc-additional-checkout-guard]'
    ).forEach(function (element) {
      if (observedGuardElements.has(element)) return;
      observedGuardElements.add(element);
      var isMessage = element.matches('[data-jfc-cart-validation-message]');
      attributeObserver.observe(element, {
        attributes: true,
        attributeFilter: attributeFilter,
        childList: isMessage,
        characterData: isMessage,
        subtree: isMessage
      });
    });
  }

  var observer = new MutationObserver(function (mutations) {
    var guardAdded = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return node.nodeType === 1 && (
          node.matches('[data-jfc-checkout-guard],[data-jfc-cart-validation-message],[data-jfc-additional-checkout-guard]') ||
          node.querySelector('[data-jfc-checkout-guard],[data-jfc-cart-validation-message],[data-jfc-additional-checkout-guard]')
        );
      });
    });
    if (!guardAdded) return;
    render();
    observeGuardAttributes();
    if (state.status === 'PENDING' && !initialFetchAttempted) refreshFromCart();
  });

  function initialize() {
    var initialState = parseCanonicalState(document);
    if (initialState) {
      commitState(initialState);
    } else {
      setPending();
      if (hasGuardElements()) refreshFromCart();
    }
    installRegionHook();
    observeGuardAttributes();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
